<template>
    <rkm-overlay>
        <template v-if="centroCusto.setor.tipoId === enums.setorTipo.RECEPCAO">
            <rkm-layout-body title="Recepção">
                <template v-slot:actions>
                    <rkm-button
                        @click="$refs.ModalAgendamento.open()"
                        color="primary"
                    >
                        Agendamentos
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalAtendimento.open()"
                        color="primary"
                    >
                        Atendimentos
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalEvasao.open()"
                        color="primary"
                    >
                        Atendidos/Evadidos
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalAmbulatorioAgendamentoConsulta.open()"
                        authorize="store-ambulatorio-agendamento"
                        color="primary"
                    >
                        Agendar consulta
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalExameLaboratorialAgendamento.open()"
                        authorize="store-exame-laboratorial-agendamento-exame"
                        color="primary"
                    >
                        Agendar exame
                    </rkm-button>

                    <rkm-button
                        @click="$refs.ModalRegulacaoSolicitacao.open()"
                        authorize="store-regulacao-solicitacao"
                        color="primary"
                    >
                        Cadastrar solicitação
                    </rkm-button>

                    <rkm-button
                        @click="$router.push({name: 'ambulatorio-recepcao-create'})"
                        authorize="store-ambulatorio-recepcao"
                        color="primary"
                    >
                        Adicionar paciente na lista
                    </rkm-button>
                </template>

                <rkm-layout-content>
                    <List />
                </rkm-layout-content>

                <ModalAgendamento ref="ModalAgendamento" />
                <ModalAmbulatorioAgendamentoConsulta ref="ModalAmbulatorioAgendamentoConsulta" />
                <ModalAtendimento ref="ModalAtendimento" />
                <ModalEvasao ref="ModalEvasao" />
                <ModalExameLaboratorialAgendamento ref="ModalExameLaboratorialAgendamento" />
                <ModalRegulacaoSolicitacao ref="ModalRegulacaoSolicitacao" />
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body title="Recepção">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>RECEPÇÃO</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/recepcao/List'
import ModalAgendamento from '@/components/ambulatorio/gerenciamento-diario/components/agendamento/Modal'
import ModalAmbulatorioAgendamentoConsulta from '@/components/ambulatorio/recepcao/components/ambulatorio-agendamento-consulta/Modal'
import ModalAtendimento from '@/components/ambulatorio/gerenciamento-diario/components/atendimento/Modal'
import ModalEvasao from '@/components/ambulatorio/gerenciamento-diario/components/evasao/Modal'
import ModalExameLaboratorialAgendamento from '@/components/ambulatorio/recepcao/components/exame-laboratorial-agendamento-exame/Modal'
import ModalRegulacaoSolicitacao from '@/components/ambulatorio/recepcao/components/regulacao-solicitacao/Modal'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: {
        List,
        ModalAgendamento,
        ModalAmbulatorioAgendamentoConsulta,
        ModalAtendimento,
        ModalEvasao,
        ModalExameLaboratorialAgendamento,
        ModalRegulacaoSolicitacao,
    },
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto'}),
    },
    data: () => ({
        enums: {setorTipo},
    }),
}
</script>